<template>
  <div class="stock-document-page-heading">
    <h1 class="stock-document-page-heading__title">
      {{ title }}
      <span v-if="code" class="stock-document-page-heading__meta"> · {{ code }}</span>
      <span v-else-if="newLabel" class="stock-document-page-heading__meta"> · {{ newLabel }}</span>
    </h1>
  </div>
</template>

<script>
export default {
  name: "StockDocumentPageHeading",
  props: {
    title: {
      type: String,
      required: true,
    },
    code: {
      type: String,
      default: "",
    },
    newLabel: {
      type: String,
      default: "",
    },
  },
};
</script>

<style scoped>
.stock-document-page-heading {
  margin-bottom: 16px;
}
.stock-document-page-heading__title {
  font-size: 1.75rem;
  font-weight: 600;
  line-height: 1.25;
  margin: 0;
  color: rgba(0, 0, 0, 0.87);
}
.stock-document-page-heading__meta {
  font-weight: 500;
  color: rgba(0, 0, 0, 0.54);
}
</style>
